import { ga4 } from '@domain-group/fe-co-allhomes-analytics';
import { OptionMap } from '../components/options/option-map';
export var moreBrowseOptionsEvent = _ref => {
  var _option$primaryCatego, _option$pageType;
  var optionName = _ref.optionName,
    position = _ref.position;
  var option = OptionMap[optionName];
  return ga4.ga4event(option.event, {
    element_is_modal: false,
    element_list_name: 'more browse options',
    element_list_position: position + 1,
    element_position: 'LHS',
    element_tab_name: '',
    element_target_anchor_link: false,
    element_target_category_primary: (_option$primaryCatego = option.primaryCategory) !== null && _option$primaryCatego !== void 0 ? _option$primaryCatego : '',
    element_target_page_type: (_option$pageType = option.pageType) !== null && _option$pageType !== void 0 ? _option$pageType : '',
    element_text: option.label,
    element_title: 'MORE BROWSE OPTIONS',
    element_type: 'text link',
    element_values_selected: ''
  });
};